import { PhotoData } from "../../photo/interfaces/dto";

export default function syncInlineEditing(
	popup: HTMLElement,
	photoData: PhotoData,
) {
	if (pm.currentUser.id !== photoData.authorId) return;

	const targets = popup.querySelectorAll(".inline-editing");
	if (!targets.length) return;

	const photoId = photoData.id;

	for (let i = 0; i < targets.length; i++) {
		const target = targets[i] as HTMLElement;
		const contentType = target.dataset.contentType;

		if (
			contentType !== "photo_description" &&
			contentType !== "photo_camera" &&
			contentType !== "photo_focal_length"
		) {
			continue;
		}

		const gridImageWrapperSelector = `.grid-image-wrapper[data-photo-id="${photoId}"]`;

		switch (contentType) {
			case "photo_description":
				target.dataset.syncEditorTo = `${gridImageWrapperSelector} .raw-photo-caption`;
				target.dataset.syncOutputTo = `${gridImageWrapperSelector} .photo-caption`;
				break;

			case "photo_camera":
				target.dataset.syncOutputTo = gridImageWrapperSelector;
				target.dataset.syncToAttr = "data-camera";
				break;

			case "photo_focal_length":
				target.dataset.syncOutputTo = gridImageWrapperSelector;
				target.dataset.syncToAttr = "data-focal-length";
				break;
		}
	}
}
